import Vue from 'vue'
import {
  SEARCH_QUERY_SET,
} from '../mutations-types'

const state = {
  searchQuery: []
}

const getters = {
  searchQuery: state => state.searchQuery
}

const mutations = {
  [SEARCH_QUERY_SET] (state, collection) {
    Vue.set(state, 'searchQuery', (collection || collection.length > 0 ? collection : []))
  }
}

const actions = {
  SEARCH_QUERY_REQUEST_GET ({ commit }, searchString) {
    return new Promise((resolve, reject) => {
      Vue.axios.get('property/FindProperty?SearchString=' + searchString)
        .then(response => {
          commit(SEARCH_QUERY_SET, response.data)
          resolve()
        }).catch( error => {
          reject(error.response.data && error.response.data.message ? error.response.data.message: error.response.data ? error.response.data: error.response)
        });
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
